import axios from 'axios';

class RequestQueue {
  constructor() {
    this.queue = [];
    this.isProcessing = false;
  }

  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async processQueue() {
    if (this.isProcessing || this.queue.length === 0) return;

    this.isProcessing = true;

    while (this.queue.length > 0) {
      const { config, resolve, reject } = this.queue.shift();

      try {
        const requestConfig = /\/(delete|send|register|message)(\?.*)?$/.test(config.url)
          ? config
          : { ...config, timeout: 30000 };

        const response = await axios(requestConfig);

        // Resolve with response if successful
        resolve(response);

      } catch (error) {
        // Reject with error if there's an issue
        reject(error);
      }
    }

    this.isProcessing = false;
  }

  requestWithQueue(config) {
    return new Promise((resolve, reject) => {
      this.queue.push({ config, resolve, reject });
      this.processQueue();
    });
  }
}

const requestQueue = new RequestQueue();

const axiosInstance = {
  requestWithQueue: requestQueue.requestWithQueue.bind(requestQueue),
};

export default axiosInstance;
